import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('VueApexCharts', VueApexCharts)
window.Apex.chart = { fontFamily: "Neo_Sans_Regular, Arial, sans-serif" };